document.addEventListener("DOMContentLoaded", function () {
  const elem = document.querySelector('#birthDate');
  const datepicker = new Datepicker(elem, {
    format: 'dd-mm-yyyy'
  });
  const gemstoneForm = document.getElementById("gemstoneForm");
  const phoneInput = document.getElementById("phone");
  const countryCodeSelect = document.getElementById("country-code");
  const DEFAULT_PHONE_RULE = { min: 6, max: 15 };
  const PHONE_RULES_BY_COUNTRY = {
    IN: { min: 10, max: 10 }
  };

  function normalizeDialCode(phoneCode) {
    const primaryCode = String(phoneCode || "").split(/\s+(?:and|or)\s+|,|\/|;/i)[0];
    const digits = primaryCode.replace(/\D/g, "");
    return digits ? `+${digits}` : "";
  }

  function getSelectedCountryOption() {
    return countryCodeSelect.options[countryCodeSelect.selectedIndex] || null;
  }

  function getSelectedPhoneRule() {
    const selectedOption = getSelectedCountryOption();
    const countryIso = selectedOption?.dataset.countryIso || "";
    return PHONE_RULES_BY_COUNTRY[countryIso] || DEFAULT_PHONE_RULE;
  }

  function getPhoneValidationMessage() {
    const selectedOption = getSelectedCountryOption();
    const selectedRule = getSelectedPhoneRule();
    const countryName = selectedOption?.dataset.countryName || "this country";

    if (selectedRule.min === selectedRule.max) {
      return `Phone number must be ${selectedRule.max} digits for ${countryName}.`;
    }

    return `Phone number must be between ${selectedRule.min} and ${selectedRule.max} digits for ${countryName}.`;
  }

  function applyPhoneValidationRule() {
    const selectedRule = getSelectedPhoneRule();
    const digitsOnly = phoneInput.value.replace(/\D/g, "").slice(0, selectedRule.max);

    phoneInput.value = digitsOnly;
    phoneInput.maxLength = selectedRule.max;
    phoneInput.minLength = selectedRule.min;
    phoneInput.placeholder = selectedRule.min === selectedRule.max
      ? `Enter ${selectedRule.max} digit mobile number`
      : "Enter Your Mobile";
  }

  function isPhoneValid(phoneNumber) {
    const selectedRule = getSelectedPhoneRule();
    const digitsOnly = phoneNumber.replace(/\D/g, "");
    return digitsOnly.length >= selectedRule.min && digitsOnly.length <= selectedRule.max;
  }

  phoneInput.addEventListener("input", applyPhoneValidationRule);
  countryCodeSelect.addEventListener("change", applyPhoneValidationRule);
  applyPhoneValidationRule();
  
  gemstoneForm.addEventListener("submit", async function (event) {
    event.preventDefault();

    const name = document.getElementById("name").value.trim(),
    email = document.getElementById("email").value.trim(),
    phone = phoneInput.value.trim(),
    gender = document.getElementById("gender").value,
    weight = document.getElementById("weight").value.trim(),
    birthDate = document.getElementById("birthDate").value,
    birthTime = document.getElementById("birthTime").value,
    countryCode = document.getElementById("country-code").value,
    birthPlace = document.getElementById("birthPlace").value.trim(),
    birthLat = document.getElementById("birthPlace").getAttribute("data-latitude"),
    birthLong = document.getElementById("birthPlace").getAttribute("data-longitude");

    let dateArr = birthDate.split("-");
    let formattedDate = `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;

    const weightRegex = /^[0-9]+$/;

    if (!name) {
      alert("Name is required.");
      return;
    }

    if (!email.includes("@") || !email.includes(".")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!isPhoneValid(phone)) {
      alert(getPhoneValidationMessage());
      return;
    }

    if (!gender) {
      alert("Please select your gender.");
      return;
    }

    if (!weightRegex.test(weight) || weight <= 0) {
      alert("Please enter a valid weight in kg.");
      return;
    }

    if (!birthDate) {
      alert("Birth date is required.");
      return;
    }

    if (!birthPlace) {
      alert("Birth place is required.");
      return;
    }

    var urlParams = {
      full_name: name,
      // birth_date: birthDate.replaceAll("-", "/"),
      birth_date: formattedDate,
      birth_time: birthTime,
      birth_place: birthPlace,
      birth_lat: birthLat,
      birth_long: birthLong,
      user_email: email,
      user_number: phone.replace(/\D/g, ""),
      country_code: countryCode,
      user_weight: weight,
      source_type: "gems_web",
    };
    // console.log(urlParams);

    const button = document.querySelector('#gemstoneForm button[type="submit"]');
    button.classList.add('loading');
    button.disabled = true;

    const apiEndpoint = "https://api.astroarunpandit.org/verified-gemstone-info";
    urlParams = new URLSearchParams(urlParams);
    await fetch(apiEndpoint + "?" + urlParams)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        renderGemstoneHtml(data);
        button.classList.remove('loading');
        button.disabled = false;
      })
      .catch((error) => {
        console.log("Error:", error);
        button.classList.remove('loading');
        button.disabled = false;
        // document.getElementById("loader").style.display = "none";
      });
  });

  const getAddressString = (address) => {
    return `${address.freeformAddress}`;
  };

  document.getElementById("birthPlace").addEventListener("input", function () {
    var birthPlaceValue = this.value;
    birthPlaceValue = birthPlaceValue.replace(/[^a-zA-Z\\s]/g, "");
    const cityNameProcess = document.getElementById("cityNameProcess");
    const timeZonesValue = document.getElementById("timeZonesValue");

    cityNameProcess.innerHTML = "<small>Enter Village, Block or City Name here<small>";
    let valueFlag = false;

    if (birthPlaceValue.length > 3) {
      cityNameProcess.innerHTML = '<b style="color:green;">Loading address details...<b>';
      // const apiUrl = `https://api.mapbox.com/search/geocode/v6/forward?q=${birthPlaceValue}&proximity=ip&access_token=pk.eyJ1IjoiZGl2eWFuc2h1a21yOTEiLCJhIjoiY21hM2pyenp4MjQ4czJvc2dnOTlhcW11diJ9.YO1a_xIwfA2m4dJdx3RtKg`;
      const apiUrl = "https://places.geo.ap-south-1.amazonaws.com/v2/suggest?key=v1.public.eyJqdGkiOiJkMjc1ZDU5MS1iMTFmLTRjZjktYjM0OS1iZTJjOWRlZTAxNWIifYYywvWa43GMbct7z19kCTi_h_A1eB5ujspF9jyPPTKb6_FlcCopZXGFkn3ty6iNpqVxvBxj4g2KQFZ7hJOj_b3lii7tfuxNtD8N15e7mfl837OCsAsgRJHnx6xd2uqdeUaogxM24_dwdoO15CTo868Jn4DVReFvwjbxNIOPlrMaOGXK4LUZNGXt3HnJQekhNjCK9bn2t4TQh4s54u7vLsNo_q9GcI3d-tD5dAK1Dpey74YVC7ZosIiAKag1IP2rcb7ZD8aOiSBHTly1Rgp9q17EcNp8UU1RvQ3BuU8QaCw13VXQ2V6bDyOjDYNbVZT1i_p5q2DdkflxAnZINc7ux0E.Njg1MGZlZTUtYTI2ZS00MDdlLWJjNDktMDNmZDlkNzVmMjQ0";

      fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ QueryText: birthPlaceValue, MaxResults: 15, Filter: { BoundingBox: [-180, -90, 180, 90] }, Language: "en", AdditionalFeatures: ["Core"] }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          timeZonesValue.innerHTML = "";

          // Mapbox
          /*const suggestions = data.features.map((result) => ({
            address: result.properties.full_address,
            coordinates: [result.properties.coordinates.latitude, result.properties.coordinates.longitude],
          }));*/

          // OpenSource
          // Amazon Location Suggest: cities / villages only (no shops or streets)
          const placeTypes = ["Locality", "District", "SubDistrict", "SubRegion", "Region", "Country"];
          const suggestions = (data.ResultItems || [])
            .filter((item) => item.Place && placeTypes.includes(item.Place.PlaceType) && item.Place.Position && item.Place.Position.length === 2)
            .map((item) => ({
              address: item.Place.PlaceType === "Region" && item.Place.Address && item.Place.Address.Region && item.Place.Address.Country ? item.Place.Address.Region.Name + ", " + item.Place.Address.Country.Name : (item.Place.Address && item.Place.Address.Label) || item.Title,
              coordinates: [item.Place.Position[1], item.Place.Position[0]],
            }))
            .slice(0, 8);

          console.log(suggestions);

          if (suggestions && suggestions.length > 0) {
            suggestions.forEach((suggestion) => {
              const option = document.createElement("li");
              option.innerHTML = suggestion.address;
              option.setAttribute("data-latitude", suggestion.coordinates[0]);
              option.setAttribute("data-longitude", suggestion.coordinates[1]);
              option.setAttribute("data-place", suggestion.address);
              option.addEventListener("click", function () {
                const s_box = document.getElementById("birthPlace");
                s_box.value = suggestion.address;
                s_box.setAttribute("data-latitude", suggestion.coordinates[0]);
                s_box.setAttribute("data-longitude", suggestion.coordinates[1]);
                s_box.setAttribute("data-place", suggestion.address);
                document.getElementById("timeZonesValue").innerHTML = "";
              });
              timeZonesValue.appendChild(option);
            });
          } else {
            cityNameProcess.innerHTML = "<small>No results found</small>";
          }
        })
        .catch((error) => {
          console.error("Error fetching address details:", error);
          cityNameProcess.innerHTML = "<small>Error loading address details</small>";
        });
    }
  });

  document.getElementById("timeZonesValue").addEventListener("input", function () {
    const cityNameProcess = document.getElementById("cityNameProcess");
    cityNameProcess.innerHTML = "";
  });

  /* Get the Country COde for the Phone Number */
  const countryData = "https://cdn.shopify.com/s/files/1/0648/0514/2781/files/country_code_and_details.json";
  fetch(countryData)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.json();
    })
    .then((data) => {
      while (document.getElementById("country-code").options.length > 0) {
        document.getElementById("country-code").remove(0);
      }

      const countries = data.countries || [];
      const selectBox = document.getElementById("country-code");

      countries.forEach((country) => {
        const dialCode = normalizeDialCode(country.phone_code);

        if (!dialCode) {
          return;
        }

        const option = document.createElement("option");
        option.value = dialCode;
        option.textContent = `${country.country_code} (${dialCode})`;
        option.dataset.countryIso = country.country_code;
        option.dataset.countryName = country.country_name || country.country_code;

        if (country.country_code === "IN") {
          option.selected = true;
        }

        selectBox.appendChild(option);
      });

      applyPhoneValidationRule();
    })
    .catch((error) => {
      console.error("Error fetching JSON data:", error);
    });

  function renderGemstoneHtml(data) {
    const resultContainer = document.getElementById("result-container");
    const resultContainerMob = document.getElementById("result-container-mob");
    resultContainer.innerHTML = "";
    var cardHtml = '';
    console.log(data.result);

    data.result.forEach(item => {
      cardHtml += `
        <div class="card">
          <div class="img-hover-zoom">
            <img src="${item.image}" alt="${item.name}">
          </div>
          <div class="card-content">
            <h2 class="card-title">${item.name}</h2>
            <p class="card-significance">${item.significance}</p>
            <div class="how-to-wear">
              <span><strong>Metal:</strong> ${item.howToWear.metal}</span>
              <span><strong>Finger:</strong> ${item.howToWear.finger}</span>
              <span><strong>Timing:</strong> ${item.howToWear.timing}</span>
              <span><strong>Weight:</strong> ${item.howToWear.weight}</span>
              <span><strong>Mantra:</strong> ${item.howToWear.mantra}</span>
            </div>
            <div class="link-btn">
              <a href="${item.url}" target="_blank">Buy Now</a>
            </div>
          </div>
        </div>
      `;
    });

    const [year, month, day] = data.date.split("/");

    const html = `
      <p id="user-details"><strong>Name:</strong> ${data.name} | <strong>Birth Place:</strong> ${data.birth_place} | <strong>DOB:</strong> ${day}/${month}/${year} | <strong>Time:</strong> ${data.time} | <strong>Weight:</strong> ${data.user_weight} Kg</p>
      <div class="gemstone-cards">
        ${cardHtml}
      </div>
    `;

    resultContainer.innerHTML = html;
    resultContainerMob.innerHTML = html;

    resultContainer.classList.add('active-result');
    resultContainerMob.classList.add('active-result');

    // Scroll to appropriate result container based on screen width
    if (window.innerWidth <= 768) {
      resultContainerMob.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      resultContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  const hoursDropdown = document.getElementById("hours");
  const minutesDropdown = document.getElementById("minutes");
  const ampmDropdown = document.getElementById("ampm");
  const hiddenInput = document.getElementById("birthTime");

  function updateHiddenTime() {
    const hours = parseInt(hoursDropdown.value, 10);
    const minutes = minutesDropdown.value;
    const ampm = ampmDropdown.value;

    let hours24 = hours;
    if (ampm === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (ampm === "AM" && hours === 12) {
      hours24 = 0;
    }
    const formattedHours = hours24.toString().padStart(2, "0");
    const time = `${formattedHours}:${minutes}`;
    console.log(time);
    hiddenInput.value = time;
  }

  hoursDropdown.addEventListener("change", updateHiddenTime);
  minutesDropdown.addEventListener("change", updateHiddenTime);
  ampmDropdown.addEventListener("change", updateHiddenTime);
});
